import React, { Component } from 'react'
import { compose } from 'react-apollo'

import { getValidationErrors } from 'helpers/validation'

import { createProject as createProjectMutation } from 'components/ProjectCreator/mutations'

import ProjectCreatorUI from 'components/ProjectCreatorUI'

class ProjectCreator extends Component {
  state = {
    creating: false,
    inputs: {
      name: '',
      url: ''
    },
    errors: {
      name: [],
      url: [],
      general: []
    }
  }

  handleSubmit = async () => {
    try {
      this.setState({
        creating: true,
        errors: {
          name: [],
          url: [],
          general: []
        }
      })

      const response = await this.props.createProject({
        name: this.state.inputs.name,
        url: this.state.inputs.url
      })

      this.props.history.push(`/projects/${response.data.createProject.project._id}`)
    } catch (error) {
      this.setState({
        creating: false,
        errors: {
          ...this.state.errors,
          ...getValidationErrors(error)
        }
      })
    }
  }

  handleValueChange = (key, value) => {
    this.setState({
      inputs: {
        ...this.state.inputs,
        [key]: value
      }
    })
  }

  render() {
    const { creating, inputs, errors } = this.state

    return (
      <ProjectCreatorUI
        isCreating={creating}

        nameValue={inputs.name}
        nameErrors={errors.name}
        onNameChange={name => this.handleValueChange('name', name)}

        urlValue={inputs.url}
        urlErrors={errors.url}
        onUrlChange={url => this.handleValueChange('url', url)}

        generalErrors={errors.general}

        onSubmit={this.handleSubmit}
      />
    )
  }
}

export default compose(
  createProjectMutation
)(ProjectCreator)



// WEBPACK FOOTER //
// ./src/components/ProjectCreator/index.js